function sum(items) {
  return items?.reduce((a, item) => a + item, 0);
}

export default sum;
